import { Anchor, FormattedText } from "client/Components";
import { ReactElement, useMemo } from "react";
import { localize } from "client_legacy/ndaw/culture";
import { SettingsPage } from "../SettingsPage";
import { useActiveSettingsMenuItem } from "../SidebarMenu/sidebarMenuSelectionStore";
import { SettingsPageKind } from "client/Api/SettingsLayout/settingsLayout";
import {
	getTermsArticles,
	TermsArticle,
	TermsArticles,
	TRUST_CENTER_SUPPORT_EMAIL_ADDRESS
} from "client/Features/Terms/termsArticles";
import { TermsArticleLinkList } from "client/Features/Terms/TermsArticleLinkList";
import { AiAssistantFabSpacing } from "client/Features/ChatAssistant/AiAssistantFabSpacing";
import styles from "./TermsPage.module.less";

export const TermsPage = (): ReactElement => {
	useActiveSettingsMenuItem(SettingsPageKind.Terms);

	const articles: TermsArticles = useMemo(
		(): TermsArticles => getTermsArticles(),
		[]
	);

	const agreements: readonly TermsArticle[] = useMemo(
		(): readonly TermsArticle[] => [
			articles.customerLicenceAgreement,
			articles.dataProcessingAgreement,
			articles.serviceLevelAgreement,
			articles.acceptableUsePolicy
		],
		[articles]
	);

	const securityPolicies: readonly TermsArticle[] = useMemo(
		(): readonly TermsArticle[] => [articles.responsibleDisclosurePolicy],
		[articles]
	);

	return (
		<SettingsPage title={localize("_Terms")}>
			<SettingsPage.Section>
				<div className={styles.content}>
					<p>{localize("_TermsPageIntroductionInfo")}</p>
					<TermsArticleLinkList articles={agreements} />
					<p>{localize("_HowToReportASecurityVulnerability")}</p>
					<TermsArticleLinkList articles={securityPolicies} />
					<p>
						<FormattedText
							text={localize("_TermsQuestionsInfo")}
							thingsToReplace={[
								{
									what: "{{EmailAnchor}}",
									filler: (
										<Anchor
											href={`mailto:${TRUST_CENTER_SUPPORT_EMAIL_ADDRESS}`}
											trackingId="support-email-link"
										>
											{TRUST_CENTER_SUPPORT_EMAIL_ADDRESS}
										</Anchor>
									)
								}
							]}
						/>
					</p>
				</div>
			</SettingsPage.Section>
			<AiAssistantFabSpacing />
		</SettingsPage>
	);
};
TermsPage.displayName = "TermsPage";

export const termsRouting = {
	page: "/Terms"
};
